export enum ModalAnalyticsEvent {
    INTENT = 'intent',
    PAGE_VIEWED = 'page_viewed',
    AGREEMENT_VIEWED = 'agreement_viewed',
    CLICK = 'click',
    OPEN_DIALOG = 'open-dialog',
    EXTERNAL_INTERACTION = 'external_interaction',
    SELECT = 'select',
    OPEN = 'open',
}
